import { useCallback, useEffect, useRef, useState } from "react";

export function useDraft<T>(key: string, initial: T) {
  const [draft, setDraft] = useState<T>(() => {
    if (typeof window === "undefined") return initial;
    try {
      const stored = localStorage.getItem(key);
      if (stored) return { ...initial, ...JSON.parse(stored) };
    } catch {}
    return initial;
  });

  // Debounce saving to localStorage
  const saveTimeout = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (saveTimeout.current) clearTimeout(saveTimeout.current);
    saveTimeout.current = setTimeout(() => {
      localStorage.setItem(key, JSON.stringify(draft));
    }, 300);
    return () => {
      if (saveTimeout.current) clearTimeout(saveTimeout.current);
    };
  }, [draft, key]);

  // Clear draft from localStorage
  const clearDraft = useCallback(() => {
    if (typeof window !== "undefined") {
      localStorage.removeItem(key);
    }
  }, [key]);

  return [draft, setDraft, clearDraft] as const;
}
